/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type TransparencyEnum = "None" | "Opaque" | "Transparent" | "%future added value";
export type EventSummaryColorCategory_event = {
    readonly title: string | null;
    readonly isClockwiseEvent: boolean;
    readonly transparency: TransparencyEnum | null;
    readonly isAllDay: boolean | null;
    readonly eventKey: {
        readonly id: string;
        readonly externalEventId: string;
        readonly orgId: string | null;
    };
    readonly annotatedEvent: {
        readonly userTags: ReadonlyArray<{
            readonly tag: string;
            readonly states: ReadonlyArray<{
                readonly value: string | null;
                readonly subjectType: SubjectUrnTypeEnum;
                readonly subjectValue: string;
                readonly lastModified: number;
                readonly active: boolean;
            }> | null;
        }> | null;
        readonly orgTags: ReadonlyArray<{
            readonly tag: string;
            readonly state: {
                readonly value: string | null;
                readonly subjectType: SubjectUrnTypeEnum;
                readonly subjectValue: string;
                readonly lastModified: number;
                readonly active: boolean;
            };
        }> | null;
    } | null;
    readonly " $refType": "EventSummaryColorCategory_event";
};
export type EventSummaryColorCategory_event$data = EventSummaryColorCategory_event;
export type EventSummaryColorCategory_event$key = {
    readonly " $data"?: EventSummaryColorCategory_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSummaryColorCategory_event">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v1 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastModified",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "EventSummaryColorCategory_event",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClockwiseEvent",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transparency",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAllDay",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "orgId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedEvent",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserTag",
                        "kind": "LinkedField",
                        "name": "userTags",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TagState",
                                "kind": "LinkedField",
                                "name": "states",
                                "plural": true,
                                "selections": (v1 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrgTag",
                        "kind": "LinkedField",
                        "name": "orgTags",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "TagState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v1 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'a99509081e09763ae51381ba9e59fae9';
export default node;
